import React from 'react';
import { List } from 'semantic-ui-react';

import { SPRAY_EVENT_WIZARD_PRODUCT_STEP } from 'services/sprayEventWizard/constants';
import { SprayEventOperation, SprayProduct } from 'services/sprayEvents/types';
import FieldValues from 'components/FieldValues';
import WizardEventSummarySection from 'components/WizardEventSummarySection';
import SummaryProductsList from './components/SummaryProductsList';

interface Props {
    readOnly: boolean;
    sprayEventOperation: SprayEventOperation;
}

export default function SummaryProducts({
    readOnly,
    sprayEventOperation
}: Props): React.ReactElement {
    return (
        <WizardEventSummarySection
            title="Spray product"
            sprayEventWizardStep={SPRAY_EVENT_WIZARD_PRODUCT_STEP}
            readOnly={readOnly}
            last
        >
            <List className="summary-list products">
                <FieldValues
                    fieldNames={[
                        'sprayProducts',
                        'sprayEntityIds',
                        'sprayApplicationRate'
                    ]}
                >
                    {({
                        sprayProducts,
                        sprayEntityIds,
                        sprayApplicationRate
                    }): React.ReactElement => {
                        return (
                            <React.Fragment>
                                {sprayProducts &&
                                    sprayProducts.map(
                                        (
                                            {
                                                id,
                                                units,
                                                perUnitType
                                            }: SprayProduct,
                                            index: number
                                        ) => (
                                            <SummaryProductsList
                                                key={id}
                                                productId={id}
                                                perUnitType={perUnitType}
                                                orderIntoTank={index + 1}
                                                product={sprayProducts[index]}
                                                entityIds={sprayEntityIds}
                                                applicationRate={
                                                    sprayApplicationRate
                                                }
                                                equipmentSetId={
                                                    sprayEventOperation?.sprayEquipmentSetId
                                                }
                                                units={units}
                                            />
                                        )
                                    )}
                            </React.Fragment>
                        );
                    }}
                </FieldValues>
            </List>
        </WizardEventSummarySection>
    );
}
